import {
  doc,
  getDoc,
  setDoc,
  updateDoc,
  serverTimestamp,
} from "firebase/firestore";
import { v4 as uuidv4 } from "uuid";
import { db } from "../firebase/firebaseConfig";

const SESSION_ID_KEY = "logisticmed_session_id";

export const forceCloseSession = async (user) => {
  if (!user?.uid) return;

  const ref = doc(db, "sesionesUsuarios", user.uid);
  const snap = await getDoc(ref);

  if (snap.exists()) {
    await updateDoc(ref, {
      activa: false,
      fechaCierre: serverTimestamp(),
    });
  }
};

export const startSession = async (user, userData = {}) => {
  const ref = doc(db, "sesionesUsuarios", user.uid);
  const snap = await getDoc(ref);

  if (snap.exists()) {
    const data = snap.data();
    const now = new Date();
    const last = data.lastActive?.toDate();

    const minutos = last
      ? (now - last) / 1000 / 60
      : null;

    if (data.activa === true && minutos !== null && minutos < 30) {
      throw new Error("SESSION_ALREADY_ACTIVE");
    }
  }

  const sessionId = uuidv4();

  /*   sessionStorage.setItem("email", user.email);
    sessionStorage.setItem("uid", user.uid);
    sessionStorage.setItem(SESSION_ID_KEY, sessionId); */

  localStorage.setItem("email", user.email);
  localStorage.setItem("uid", user.uid);
  localStorage.setItem(SESSION_ID_KEY, sessionId);

  await setDoc(ref, {
    uid: user.uid,
    correo: user.email,
    sessionId,
    activa: true,
    emp_id: userData.emp_id || "",
    nombre: userData.nombre || "",
    apellido: userData.apellido || "",
    rol: userData.rol || "",
    fechaInicio: serverTimestamp(),
    lastActive: serverTimestamp(),
    dispositivo: navigator.userAgent,
  });

  return sessionId;
};

export const validateSession = async (user) => {
  if (!user?.uid) return false;

  /*  const sessionIdLocal = sessionStorage.getItem(SESSION_ID_KEY); */
  const sessionIdLocal = localStorage.getItem("logisticmed_session_id");

  if (!sessionIdLocal) return false;

  const ref = doc(db, "sesionesUsuarios", user.uid);
  const snap = await getDoc(ref);

  if (!snap.exists()) return false;

  const data = snap.data();

  if (data.activa !== true) return false;

  return data.sessionId === sessionIdLocal;
};

export const endSession = async (user) => {
  if (user?.uid) {
    const ref = doc(db, "sesionesUsuarios", user.uid);
    const snap = await getDoc(ref);
    const sessionIdLocal = localStorage.getItem(SESSION_ID_KEY);

    if (snap.exists()) {
      const data = snap.data();

      if (data.sessionId === sessionIdLocal) {
        await updateDoc(ref, {
          activa: false,
          fechaCierre: serverTimestamp(),
        });
      }
    }
  }
  /* 
    sessionStorage.clear(); */
  localStorage.removeItem("email");
  localStorage.removeItem("uid");
  localStorage.removeItem("logisticmed_session_id");
};

export const getSession = () => {
  return {
    /*  email: sessionStorage.getItem("email"),
     uid: sessionStorage.getItem("uid"),
     sessionId: sessionStorage.getItem(SESSION_ID_KEY), */
    email: localStorage.getItem("email"),
    uid: localStorage.getItem("uid"),
    sessionId: localStorage.getItem(SESSION_ID_KEY),

  };
};

export const isLoggedIn = () => {
  return !!getSession().email;
};